/**
 * Importação da classe genérica para requisições em serviços
 */
import GenericCrud from './GenericCrud';

/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

/**
 * Classe que realiza as requisições no GeoServer
 */
export default class GeoServer extends GenericCrud {
  constructor(apiVersion = '/v1') {
    super('geo-server', apiVersion);
  }

  /**
   * Método de requisição de uma camada
   *
   * @param {*} layer
   */
  async getOne(layer) {
    return axios(
      `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}`,
      {
        params: {
          layer,
        },
      }
    );
  }
}
